import React from 'react';
import styled from 'styled-components';

const StyledLogo = styled.img.attrs((props) => ({
    src: props.src
}))``;

const Logo = ({ src }) => {
    return <StyledLogo src={src} />;
};

export default Logo;
